import { useOfficialDailyDetailDispatch } from './official-daily-detail-context';
import { ACTION_TYPES } from './official-daily-detail-reducer';
import PortalAppService from '../../../application/platform/portal-app-service';

export const useOfficialDailyDetailController = () => {
  const dispatch = useOfficialDailyDetailDispatch();

  async function loadDetail(id: number) {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      const detailData = await PortalAppService.getOfficialDailyDetail(id);
      dispatch({ type: ACTION_TYPES.loadingDetail, payload: detailData });
    } catch (error) {
      console.error('Error loading official daily detail:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da edição' });
    }
  }

  function clearData() {
    dispatch({ type: ACTION_TYPES.clearData });
  }

  return {
    loadDetail,
    clearData,
  };
};
